<template>
    <el-dialog
        title="新闻"
        :visible.sync="isVisible"
        :close-on-click-modal="false"
    >
        <el-form
            :model="form"
            label-position="top"
            ref="form"
        >
            <el-form-item label="封面">
                <ox-uploader
                    :drag="false"
                    accept=".jpg,.png,.jpeg"
                    list-type="picture-card"
                    category-id="5d3455f59d8c9c60184e5d8d"
                    :file-list="form.cover?[form.cover]:[]"
                    @success="onCoverUploaded"
                    @remove="onCoverRemoved"
                />
            </el-form-item>
            <el-row :gutter="15">
                <el-col :span="20">
                    <el-form-item label="标题">
                        <el-input
                            v-model="form.title"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="状态">
                        <el-checkbox v-model="form.is_published">发布</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="详细介绍">
                <ox-editor
                    category-id="5d34561d9d8c9c6190b8e0aa"
                    v-model="form.content"
                />
            </el-form-item>
        </el-form>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                @click="hide"
                round
            >取 消</el-button>
            <el-button
                type="primary"
                @click="save"
                round
                :loading="isProcessing"
            >确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import OxUploader from "../../ox/components/form/OxUploader";
import OxEditor from "../../ox/components/form/OxEditor";

export default {
    name: "DemandFormDialog",
    components: {
        OxUploader,
        OxEditor
    },
    data: function() {
        return {
            isProcessing: false,
            isVisible: false,
            form: {
                id: null,
                cover: null,
                title: null,
                is_published: true,
                content: null
            }
        };
    },
    methods: {
        reset() {
            this.form = {
                id: null,
                cover: null,
                title: null,
                is_published: true,
                content: null
            };
        },
        show(data = null) {
            if (data) {
                this.form = {
                    id: data.id,
                    cover: data.cover,
                    title: data.title,
                    content: data.content,
                    is_published: data.is_published
                };
                if (this.form.cover) {
                    this.form.cover.url = this.form.cover.path;
                }
            } else {
                this.reset();
            }
            this.isVisible = true;
        },
        hide() {
            this.isVisible = false;
        },
        onCoverUploaded(resp, file) {
            this.form.cover = file;
        },
        onCoverRemoved() {
            this.form.cover = null;
        },
        save() {
            this.isProcessing = true;
            this.$ox
                .service("article")
                .save(this.form)
                .then(res => {
                    this.$notify.success({
                        title: "操作成功",
                        message: `文章“${this.form.title}”已保存`
                    });
                    this.hide();
                    this.$refs.form.resetFields();
                    this.$refs.form.clearValidate();
                    this.$emit("success", res);
                })
                .catch(err => {
                    this.$emit("error", err);
                    this.$notify.error({
                        title: "操作失败",
                        message: "请与系统维护人员联系"
                    });
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        }
    }
};
</script>

<style scoped>
</style>